export function excelSerialToDate(serial: number): Date {
  if (!Number.isFinite(serial) || serial < 1) return new Date(NaN);
  const epoch = new Date(1899, 11, 30);
  return new Date(epoch.getTime() + serial * 86400000);
}

export function formatDateISO(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function formatDateDisplay(date: Date): string {
  if (isNaN(date.getTime())) return 'Invalid date';
  return date.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' });
}

export function parseTimeStr(time: string): { hours: number; minutes: number } {
  if (!time || time.length < 3) return { hours: NaN, minutes: NaN };
  const padded = time.padStart(4, '0');
  return {
    hours: parseInt(padded.substring(0, 2), 10),
    minutes: parseInt(padded.substring(2, 4), 10),
  };
}

export function createShiftDate(
  dayDate: Date,
  timeStr: string,
  isEndDate = false,
  startTimeStr?: string
): Date {
  const { hours, minutes } = parseTimeStr(timeStr);
  if (isNaN(hours) || isNaN(minutes)) return new Date(NaN);
  const d = new Date(dayDate);
  d.setHours(hours, minutes, 0, 0);
  if (isEndDate && startTimeStr) {
    const start = parseTimeStr(startTimeStr);
    const startMins = start.hours * 60 + start.minutes;
    const endMins = hours * 60 + minutes;
    if (endMins <= startMins) d.setDate(d.getDate() + 1);
  }
  return d;
}

export function formatTimeForDisplay(time: string): string {
  if (!time || time.length < 4) return time || '';
  const h = parseInt(time.substring(0, 2), 10);
  const m = time.substring(2);
  return `${h}:${m}`;
}
